__turbopack_context__.v({
  "nativeSelect": "spEZAG_nativeSelect",
  "styledSelect": "spEZAG_styledSelect",
});
